module.exports = __webpack_public_path__ + "static/media/icon_pgcode_account_transfer.1ae94ceb.svg";